<template>
  <div>
    <WebsiteHeader></WebsiteHeader>
    <h1>Onboarding Completed ...</h1>
    <WebsiteFooter></WebsiteFooter>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import helpersJs from "@/plugins/helpers";
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";
import WebsiteFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";
export default {
  data: () => ({
    user: null,
    company: null,
  }),
  components: { WebsiteHeader, WebsiteFooter },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  async mounted() {
    if (!localStorage.getItem("garbage")) {
      this.$router.push({ path: "/" });
      return false;
    }
    this.$store.commit("setLoader", true);
    this.user = JSON.parse(localStorage.getItem("user"));
    this.company = JSON.parse(localStorage.getItem("company"));

    await this.registerUser();
    this.$store.commit("setLoader", false);
  },
  methods: {
    async registerUser() {
      const axiosPromise = await axios.postData("/auth/register", {
        name: this.user.name,
        email: this.user.email,
        tel: this.user.tel,
        password: this.user.password,
        emis: this.company.emis,
      });

      if (
        axiosPromise.message &&
        axiosPromise.message.includes("successfully")
      ) {
        const loggegIn = await helpersJs.login(
          this.user.email,
          this.user.password
        );

        if (loggegIn) {
          this.createCompany();
        }
      }
    },
    createCompany() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/create-company",
          {
            name: this.company.name,
            description: "We are a general company",
            primaryPhone: this.company.primary_phone,
            primaryAddress: this.company.primary_address,
            city: this.company.city,
            email: this.company.email,
            emis: this.company.emis,
          },
          this.getAccessToken
        )
        .then((response) => {
          this.$store.commit("setLoader", false);
          if (response == "success") {
            this.$router.push({ name: "switchboard" });
          }
        });
    },
  },
};
</script>
